import React, {useState, useEffect} from "react";

import { TextField, Autocomplete } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import { addZone, addZoneSpace, getSiteSpaces, getBuildingSpaces } from "../../services/MetadataService";
import { getBrickZoneTypes } from "../../services/DimensionsServices"

const AddZoneForm = (props) => {
    let [spaces, setSpaces] = useState()
    let [name, setName] = useState()
    let [type, setType] = useState()

    let [brickTypes, setBrickTypes] = useState()
    let [selectedSpaces, setSelectedSpaces] = useState([])
    let [isSubmitting, setIsSubmitting] = useState(false)

    let[error, setError] = useState('')


    useEffect(() => {
        getBrickZoneTypes().then(response => {
            console.log(response)
            setBrickTypes(response)
        })
    }, [])

    useEffect(() => {
        if (props.buildingId) {
            getBuildingSpaces(props.buildingId).then(response => {
                response.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setSpaces(response)
            })
        } else if (props.siteId) {
            getSiteSpaces(props.siteId).then(response => {
                response.sort((a, b) => (a.name > b.name) ? 1 : -1)
                setSpaces(response)
            })
        }
    }, [props.siteId, props.buildingId])

    const handleSubmit = () => {
        console.log('Doing the submit')


        if (name && type) {
            setIsSubmitting(true);

            let zone = {
                site_id: props.siteId,
                name: name,
                brick_zone_type: type,
            }

            addZone(zone).then(response => {
                let zone_id = response.id;
                console.log(response);
                setIsSubmitting(false);

                if (selectedSpaces && selectedSpaces.length > 0) {

                    selectedSpaces.forEach(space => {
                        setIsSubmitting(true);
                        addZoneSpace(zone_id, {space_id: space.id}).then(response => {
                            console.log("Space added")
                            console.log(response)
                            setError('')
                            setIsSubmitting(false);
                        }).catch(err => {
                            console.log("Error adding space")
                            setError(err)
                            setIsSubmitting(false);
                        })
                    })
                }

            }).catch(err => {
                console.log("Error adding zone")
                setError(err)
                setIsSubmitting(false)
            })
        }
    }

    console.log(brickTypes)
    return (
        <div className="layer3">
            <div className="bulk-add-form">
                <div className="row-error">
                    {error}
                </div>
                <div className="row-form-field">
                    <TextField label="Name" variant="outlined" size="small" onChange={(e) => {setName(e.target.value)}} fullWidth required/>
                </div>
                <div className="row-form-field">
                    <Autocomplete
                        disablePortal
                        id="types"
                        options={brickTypes || []}
                        getOptionLabel={option => option.name}
                        renderInput={(params) => <TextField {...params} label="Zone Type" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setType(newValue.brick_zone_type);
                        }}
                    />
                </div>


            {
                spaces  ?
                <div className="row-form-field">
                    <Autocomplete
                        id="spaces"
                        options={spaces || []}
                        getOptionLabel={option => option.name}
                        multiple={true}
                        isOptionEqualToValue={(option, value) => option.name === value.name}
                        renderInput={(params) => <TextField {...params} label="Select spaces for this zone" variant="outlined" fullWidth size="small" />}
                        onChange={(event, newValue) => {
                            setSelectedSpaces(newValue);
                        }}
                    />
                </div> : null
            }

                <div className="row-button-container">
                    <LoadingButton
                        variant="contained"
                        loading={isSubmitting}
                        type="submit"
                        onClick={handleSubmit}
                        sx={{position: "absolute", right: 0, backgroundColor: "#003e51"}}>
                            Submit
                    </LoadingButton>
                </div>
            </div>
        </div>

    )


}

export default AddZoneForm;